import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { Card, List, Typography, Progress, Button, Avatar, Space, Empty, Tooltip } from "antd";
import { ApartmentOutlined, TeamOutlined } from "@ant-design/icons";
import { useContext } from "react";
import { ProfileContext } from "Common/hooks/context/ProfileContext";
const { Text } = Typography;
const Trainings = ({ darkMode, trainings = [] }) => {
  const { isProfileComplete } = useContext(ProfileContext)
  const isBlocked = !isProfileComplete;
  const navigate = useNavigate();
  const styles = {
    card: {
      borderRadius: 8,
      marginBottom: 24,
      backgroundColor: darkMode ? "#1f1f1f" : "#fff",
      borderColor: darkMode ? "#303030" : "#f0f0f0",
      opacity: isBlocked ? 0.6 : 1,
      pointerEvents: isBlocked ? "none" : "auto"
    },
    cardTitle: {
      color: darkMode ? "rgba(255, 255, 255, 0.85)" : undefined,
    },
    trainingCard: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
    },
    listItem: {
      padding: "8px 0",
      borderBottom: `1px solid ${darkMode ? "#303030" : "#f0f0f0"}`,
      cursor: "pointer",
      transition: "all 0.3s",
    },
    avatarIcon: {
      backgroundColor: darkMode ? "#2a2a2a" : "#f0f0f0",
      color: darkMode ? "#ffffff" : "#9A6B0E",
      transition: "all 0.3s ease",
    },
    textColor: {
      color: darkMode ? "rgba(255, 255, 255, 0.85)" : undefined,
      transition: "all 0.3s ease",
    },
    secondaryTextColor: {
      color: darkMode ? "rgba(255, 255, 255, 0.45)" : "rgba(0, 0, 0, 0.45)",
      transition: "all 0.3s ease",
    },
    noData: {
      textAlign: "center",
      padding: "24px 0",
      color: darkMode ? "rgba(255, 255, 255, 0.45)" : "#999",
    },
    footer: {
      display: "flex",
      justifyContent: "flex-end",
      paddingTop: "16px",
      borderTop: `1px solid ${darkMode ? "#303030" : "#f0f0f0"}`,
      marginTop: "auto",
    },
  };
  return (
    <Card
      title={
        <Space style={{ display: "flex", justifyContent: "space-between" }}>
          <span style={styles.cardTitle}>
            <TeamOutlined style={{ marginRight: 8 }} />
            All Trainings
          </span>
        </Space>
      }
      style={{ ...styles.card, ...styles.trainingCard }}
      styles={{ header: styles.cardTitle }}
    >
      {trainings.length === 0 ? (
        <Empty description="No Trainings Assigned Yet" />
      ) : (
        <>
          <List
            itemLayout="horizontal"
            dataSource={trainings.slice(0, 3)}
            renderItem={(training) => {
              const listItem = (
                <div style={{ position: "relative" }}>
                  {training.isRetryTraining && <div className="ribbon-Badge">Repeated</div>}
                  <Tooltip title={isBlocked ? "Complete your Profile first" : ""}>
                    <List.Item
                      style={{
                        backgroundColor: darkMode ? "#2a2a2a" : "#fff",
                        borderColor: darkMode ? "#404040" : "#f0f0f0",
                        transition: "all 0.3s",
                        cursor: isBlocked ? "not-allowed" : "pointer",
                      }}
                      onMouseEnter={(e) => {
                        if (isBlocked) return;
                        e.currentTarget.style.backgroundColor = darkMode ? "#2a2a2a" : "#f5f5f5";
                        e.currentTarget.style.transform = "translateX(4px)";
                      }}
                      onMouseLeave={(e) => {
                        if (isBlocked) return;
                        e.currentTarget.style.backgroundColor = darkMode ? "#2a2a2a" : "#fff";
                        e.currentTarget.style.transform = "translateX(0)";
                      }}
                      onClick={() =>
                        !isBlocked &&
                        navigate("/mentor/learners-by-training", {
                          state: { trainingId: training.id, darkMode },
                        })
                      }
                    >
                      <List.Item.Meta
                        avatar={
                          <Avatar
                            icon={<ApartmentOutlined />}
                            style={{ ...styles.avatarIcon, transition: "all 0.3s ease" }}
                          />
                        }
                        title={
                          <Text strong style={{ ...styles.textColor, transition: "all 0.3s ease" }}>
                            {training.title}
                          </Text>
                        }
                        description={
                          <>
                            <Progress
                              percent={training.progress}
                              size="small"
                              strokeColor={darkMode ? "#ffffff" : "#9A6B0E"}
                              format={(percent) => (
                                <span style={{ color: darkMode ? "#ffffff" : "#000000" }}>
                                  {percent}% complete
                                </span>
                              )}
                            />
                            <Text style={styles.secondaryTextColor}>
                              Group Name: {training.groupName}
                            </Text>
                          </>
                        }
                      />
                    </List.Item>
                  </Tooltip>
                </div>
              );
              return listItem;
            }}
          />
          <div style={styles.footer}>
            <Tooltip title={isBlocked ? "Complete your Profile first" : ""}>
              <Button
                type="link"
                disabled={isBlocked}
                onClick={() =>
                  !isBlocked &&
                  navigate("/mentor/all-trainings", {
                    state: { trainings, darkMode },
                  })
                }
              >
                View All
              </Button>
            </Tooltip>
          </div>
        </>
      )}
    </Card>
  );
};
Trainings.propTypes = {
  darkMode: PropTypes.bool.isRequired,
  trainings: PropTypes.array,
  blockAction: PropTypes.bool
};
export default Trainings;
